import { render, staticRenderFns } from "./date-picker.vue?vue&type=template&id=1243d008&scoped=true&"
import script from "./date-picker.vue?vue&type=script&lang=js&"
export * from "./date-picker.vue?vue&type=script&lang=js&"
import style0 from "./date-picker.vue?vue&type=style&index=0&id=1243d008&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.7_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1243d008",
  null
  
)

export default component.exports